module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['menu', 'clearfix', _vm.stateOpen ? 'menu--open' : '']
  }, [_c('button', {
    attrs: {
      "type": "button",
      "name": "menu"
    },
    on: {
      "click": _vm.setMenuState
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.stateOpen) ? _c('nav', [_c('ul', [_c('li', {
    on: {
      "click": _vm.setMenuState
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Jeu")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.setMenuState
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/biographies"
    }
  }, [_vm._v("Personnages")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.setMenuState
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/reglement"
    }
  }, [_vm._v("Règlement")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.setMenuState
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), _c('socials')], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d32cc1e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/menu/Menu.vue
// module id = 94
// module chunks = 0